import mainMenu from "../views/mainMenu";

let mainMenuRouter = [];
mainMenuRouter = [
    {
        path: "/mainMenu",
        meta: {
            title: "",
            type: "noChild",
            //icon:'http://img.cdn.wxzhida.cn//zdj4/menu/yidongduan.png',
        },
        name: "mainMenu",
        component: mainMenu,
    },
]
export default mainMenuRouter ;
